import { privateApi } from "./axios"


export const updateRefund = async (id: number, data: any) => {
    try {
        const response = await privateApi.patch(`api/reimbursements/${id}`, data)
        return response
    } catch (error) {
        throw error
    }
}

export const deleteRefund = async (id: number) => {
    try {
        const response = await privateApi.delete(`api/reimbursements/${id}`)
        return response
    } catch (error) {
        throw error
    }
}

export const getRefund = async (id: number) => {
    try {
        const response = await privateApi.get(`api/reimbursements/${id}`)
        return response
    } catch (error) {
        throw error
    }
}
